<template>
    <div>
        <producto-crud></producto-crud>
    </div>
</template>     

<script>
import ProductoCrud from '@/components/producto/ProductoCrud'
export default {
    name: 'Producto',
    components: {
        ProductoCrud
    },
    data: () => {
        return {

        }
    }
}
</script>

